import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/PaymentReport/SearchReport",
    method: "get",
    params
  });
}
export function getColumns(params) {
  return request({
    url: "/PaymentReport/GetReportHeader",
    method: "get",
    params
  });
}
